import {
  CheckCircle2,
  Circle,
  Clock,
  HelpCircle,
  ChevronRight,
  Info
} from 'lucide-react'
import './styles.scss'

export default function SemesterTimeline({ data, onCourseClick }) {
  // data expected to be list of semesters, each with courses
  const semesters = data || [];

  const getStatusIcon = (status) => {
    switch (status) {
      case 'transferred': return <CheckCircle2 className="icon-success" size={18} />;
      case 'complete': return <CheckCircle2 className="icon-complete" size={18} />;
      case 'remaining': return <Clock className="icon-pending" size={18} />;
      default: return <Circle className="icon-default" size={18} />;
    }
  }

  return (
    <div className="semester-timeline-professional">
      {semesters.map((semester, idx) => (
        <div key={idx} className={`timeline-segment ${semester.status}`}>
          <div className="timeline-node">
            <div className="node-marker">
              <span className="node-dot"></span>
            </div>
            <div className="node-content">
              <h3 className="semester-title">{semester.name}</h3>
              <div className="course-list-inline">
                {semester.courses.map((course, cidx) => (
                  <div
                    key={cidx}
                    className={`course-card-mini status-${course.status}`}
                    onClick={() => onCourseClick && onCourseClick(course)}
                  >
                    <div className="course-info">
                      {getStatusIcon(course.status)}
                      <div className="text-stack">
                        <div className="code-row">
                          <span className="code">{course.code}</span>
                          <span className="credits-badge">{course.credits} {course.credits === 1 ? 'CREDIT' : 'CREDITS'}</span>
                        </div>
                        <span className="title">{course.title}</span>
                      </div>
                    </div>
                    <ChevronRight size={14} className="arrow-hint" />
                  </div>
                ))}
              </div>
            </div>
          </div>
          {idx < semesters.length - 1 && <div className="connector-line"></div>}
        </div>
      ))}
    </div>
  )
}
